import React, { useState } from 'react';
import './portfolio.css';
import project1Image from '../../img/projects/project-1.png';
import project2Image from '../../img/projects/project-2.png';
import project3Image from '../../img/projects/project-3.png';
import project4Image from '../../img/projects/project-4.png';
import project5Image from '../../img/projects/project-5.png';
import project6Image from '../../img/projects/project-6.png';
import project7Image from '../../img/projects/project-7.png';
import project8Image from '../../img/projects/project-8.png';
import project9Image from '../../img/projects/project-9.png';
import project10Image from '../../img/projects/project-10.png';
import project11Image from '../../img/projects/project-11.png';
import project12Image from '../../img/projects/project-12.png';
import project15Image from '../../img/projects/project-15.png';
import project34Image from '../../img/projects/project-34.png';
import project35Image from '../../img/projects/project-35.png';
import project36Image from '../../img/projects/project-36.png';
import webDesignIcon from '../../img/icons/shopify.jpg';
import mobileAppIcon from '../../img/icons/web.jpg';
import fullStackIcon from '../../img/icons/fullstack.jpg';
import AllIcon from '../../img/icons/all.jpeg'

const projects = [
  {
    id: 1,
    title: 'Shopify Development',
    description: 'Experience the power of Shopify e-commerce with our premium solution, meticulously crafted and customized to meet your unique business needs.',
    image: project1Image,
    link: 'https://zilapz.com/',
    tags: ['Shopify', 'E-commerce', 'Responsive'],
    keywords: ['Shopify', 'E-commerce', 'At Meta Tech'],
    category: 'Shopify Development',
    categoryId: 'shopify',
    icon: mobileAppIcon
  },
    {
        id: 2,
        title: 'Shopify Development',
        description: 'Experience the power of Shopify e-commerce with our premium solution, meticulously crafted and customized to meet your unique business needs.',
        image: project2Image,
        link: 'https://shoppermaze.com/',
        tags: ['Shopify', 'E-commerce', 'Responsive'],
        keywords: ['Shopify', 'E-commerce', 'At Meta Tech'],
        category: 'Shopify Development',
        categoryId: 'shopify',
        icon: mobileAppIcon
      },
      {
        id: 3,
        title: 'Shopify Development',
        description: 'Elevate your online store with our custom Shopify development services, tailored to perfection for an unparalleled user experience.',
        image: project3Image,
        link: 'https://12438d-4e.myshopify.com',
        tags: ['Shopify', 'E-commerce', 'Responsive'],
        keywords: ['Shopify', 'E-commerce', 'At Meta Tech'],
        category: 'Shopify Development',
        categoryId: 'shopify',
        icon: webDesignIcon
      },
      {
        id: 4,
        title: 'Shopify Development',
        description: 'Transform your e-commerce vision into reality with our bespoke Shopify development, featuring cutting-edge design and functionality.',
        image: project4Image,
        link: 'https://thebeautifulglow.com/',
        tags: ['Shopify', 'E-commerce', 'Responsive'],
        keywords: ['Shopify', 'E-commerce', 'At Meta Tech'],
        category: 'Shopify Development',
        categoryId: 'shopify',
        icon: mobileAppIcon
      },
      {
        id: 5,
        title: 'Shopify Development',
        description: 'Harness our expertise in Shopify e-commerce development to create a seamless online shopping experience for your customers.',
        image: project5Image,
        link: 'https://healthysurprises.com/',
        tags: ['Shopify', 'E-commerce', 'Responsive'],
        keywords: ['Shopify', 'E-commerce', 'At Meta Tech'],
        category: 'Shopify Development',
        categoryId: 'shopify',
        icon: fullStackIcon
      },
      {
        id: 6,
        title: 'Shopify Development',
        description: 'Unlock the full potential of Shopify with our comprehensive full-stack solutions, combining design, development, and optimization.',
        image: project6Image,
        link: 'https://thehomeandkitchen.com/',
        tags: ['Shopify', 'E-commerce', 'Responsive'],
        keywords: ['Shopify', 'E-commerce', 'At Meta Tech'],
        category: 'Shopify Development',
        categoryId: 'shopify',
        icon: fullStackIcon
      },
      {
        id: 7,
        title: 'E-commerce Website with React.js',
        description: 'Experience the future of online shopping with our cutting-edge e-commerce website, meticulously crafted using React.js for seamless user interaction.',
        image: project7Image,
        link: 'https://baltistanorganicdryfruits.netlify.app/',
        tags: ['HTML', 'CSS', 'JavaScript'],
        keywords: ['HTML', 'CSS', 'JavaScript'],
        category: 'Frontend Development',
        categoryId: 'frontend',
        icon: webDesignIcon
      },
      {
        id: 8,
        title: 'React.js E-commerce Web Application',
        description: 'Immerse your customers in a sleek and intuitive online shopping experience with our React.js-powered e-commerce web application, designed to elevate user interaction.',
        image: project8Image,
        link: 'https://easycareskin.netlify.app/',
        tags: ['React.js', 'JavaScript', 'Responsive'],
        keywords: ['React.js', 'JavaScript', 'Responsive'],
        category: 'Frontend Development',
        categoryId: 'frontend',
        icon: webDesignIcon
      },
      {
        id: 9,
        title: 'Software Company with React js',
        description: 'Explore the expertise of our software company through an elegant and interactive portfolio website, meticulously crafted with React.js to showcase our skills and projects.',
        image: project9Image,
        link: 'https://cybernovadynamics.netlify.app/',
        tags: ['React.js', 'JavaScript', 'Responsive'],
        keywords: ['React.js', 'JavaScript', 'Portfolio'],
        category: 'Frontend Development',
        categoryId: 'frontend',
        icon: webDesignIcon
      },
      {
        id: 10,
        title: 'Dynamic Car Selling Platform',
        description: 'Experience the future of car buying with our dynamic and user-friendly e-commerce platform, developed using React.js for a seamless shopping experience.',
        image: project10Image,
        link: 'https://carvillaprojectbywazirmubashir.netlify.app/',
        tags: ['React.js', 'JavaScript', 'E-commerce'],
        keywords: ['React.js', 'JavaScript', 'E-commerce'],
        category: 'Frontend Development',
        categoryId: 'frontend',
        icon: webDesignIcon
      },
      {
        id: 11,
        title: "Developer Portfolio with React.js",
        description: "Our developer portfolio website, crafted with precision and expertise, showcases modern design and seamless user experience, all powered by React.js. It's tailored for individuals seeking to elevate their online presence, offering intuitive navigation and captivating visuals for a memorable browsing experience.",
        image: project11Image,
        link: "https://mubashir-dev.netlify.app/",
        tags: ["Portfolio", "Personal Website", "React.js"],
        keywords: ["Portfolio", "Personal Website", "React.js"],
        category: "Frontend Development",
        categoryId: "frontend",
        icon: webDesignIcon
      },
      {
        id: 12,
        title: "Agency Website with React.js",
        description: "Experience our sleek and intuitive web application, developed with React.js for enhanced user interaction. Explore our services, portfolio, and more with ease.",
        image: project12Image,
        link: "https://superagency-inno.netlify.app/",
        tags: ["React.js", "JavaScript", "Responsive"],
        keywords: ["React.js", "JavaScript", "Responsive"],
        category: "Frontend Development",
        categoryId: "frontend",
        icon: webDesignIcon
      },
      {
        id: 13,
        title: "Full-Stack E-commerce Website with React.js",
        description: "Experience seamless user interaction with our sleek and intuitive full-stack e-commerce website, developed with React.js. Combining MongoDB and Node.js, we deliver a responsive platform for your online business needs.",
        image: project34Image,
        link: "https://superagency-inno.netlify.app/",
        tags: ["React.js", "JavaScript", "Responsive"],
        keywords: ["React.js", "JavaScript", "Responsive"],
        category: "Frontend Development",
        categoryId: "frontend",
        icon: webDesignIcon
      },
      {
        id: 14,
        title: "Full-Stack E-commerce Website with React.js",
        description: "Immerse your customers in an enhanced online shopping experience with our sleek and intuitive full-stack e-commerce website, powered by React.js. Leveraging MongoDB and Node.js, we deliver a responsive platform for your business success.",
        image: project35Image,
        link: "https://superagency-inno.netlify.app/",
        tags: ["React.js", "JavaScript", "Responsive"],
        keywords: ["React.js", "JavaScript", "Responsive"],
        category: "Frontend Development",
        categoryId: "frontend",
        icon: webDesignIcon
      },
      {
        id: 15,
        title: "Medical Healthcare Full-Stack Website",
        description: "Transform healthcare delivery with our comprehensive medical healthcare full-stack website. Built with cutting-edge technologies like React.js, MongoDB, and Node.js, our platform ensures seamless interaction and accessibility for patients and providers alike.",
        image: project15Image,
        link: "#",
        tags: ["React.js", "MongoDB", "Node.js"],
        keywords: ["React.js", "Healthcare", "Medical"],
        category: "Full Stack Development",
        categoryId: "fullstack",
        icon: fullStackIcon
      },
      {
        "id": 16,
        "title": "Creative Agency Portfolio with React.js",
        "description": "Present your agency's portfolio in style with our dynamic portfolio website crafted with React.js. Showcase your creativity and services seamlessly.",
        "image": project36Image,
        "link": "https://innosyncweb.netlify.app/",
        "tags": ["React.js", "JavaScript", "Portfolio"],
        "keywords": ["React.js", "JavaScript", "Portfolio", "Agency"],
        "category": "Frontend Development",
        "categoryId": "frontend",
        "icon": webDesignIcon,
      }

  ];

const Portfolio = () => {
  const [selectedTab, setSelectedTab] = useState('All');
  const [activeTab, setActiveTab] = useState('All');

  const handleTabClick = (tab) => {
    setSelectedTab(tab);
    setActiveTab(tab);
  };

  const filteredProjects = selectedTab === 'All' ? projects : projects.filter(project => project.categoryId === selectedTab);

  return (
    <div className="portfolio-section">
      <h2>Explore My Projects</h2>
      <div className="tabs-container">
        <button className={activeTab === 'All' ? 'active' : ''} onClick={() => handleTabClick('All')}>
        <img src={AllIcon} alt="All" className="tab-icon" />
          All
        </button>
        <button className={activeTab === 'shopify' ? 'active' : ''} onClick={() => handleTabClick('shopify')}>
          <img src={webDesignIcon} alt="Shopify Development" className="tab-icon" />
          Shopify Development
        </button>
        <button className={activeTab === 'frontend' ? 'active' : ''} onClick={() => handleTabClick('frontend')}>
          <img src={mobileAppIcon} alt="Front-end Development" className="tab-icon" />
          Front-end Development
        </button>
      </div>
      <div className="projects">
    {filteredProjects.map(project => (
      <div key={project.id} className="project-card">
        <div className="tags">
          {project.tags.map((tag, index) => (
            <span key={index} className="tag">{tag}</span>
          ))}
        </div>
        <img src={project.image} alt={project.title} />
        <div className="project-info">
          <h3>{project.title}</h3>
          <p>{project.description}</p>
          <div className="keywords">
            {project.keywords.map((keyword, index) => (
              <span key={index} className="keyword">{keyword}</span>
            ))}
          </div>
          {/* Link button */}
          <a href={project.link} className="project-link-button" target="_blank" rel="noopener noreferrer">
            View Project
          </a>
        </div>
      </div>
    ))}
  </div>
  <div className='primary-btn-container'>
    <button className="primary-button">View More</button>
  </div>
</div>
  );
};

export default Portfolio;